import script from "./sliderCanvas.vue?vue&type=script&lang=js"
export * from "./sliderCanvas.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__